import { useEffect, useMemo, useState } from 'react'

import { useAppDispatch, useAppSelector } from 'app/hooks'
import { useHomeRouteParams } from 'features/home/hooks'
//import { fetchHomeSubscriptionPriceThunk } from 'features/home/components/HomeSubscription/SubscriptionDetails/slice'
import {
  subscriptionApDevicePriceSelector,
  subscriptionPeriodEndSelector,
} from 'features/home'
//import { fetchHomeThunk } from 'features/home'
import { subscriptionEssentialsPriceSelector } from 'features/home'
import {
  subscribedAccessPointsSelector,
  subscribedEssentialsSelector,
} from 'features/networkAi/selectors'
import {
  selectedHomeSelector,
  subscriptionStatusSelector,
  subscriptionsCreditSelector,
} from 'features/home/selectors'
import {
  fetchSubscriptionPricesSliceThunk,
  fetchSubscriptionPeriodEndSliceSliceThunk,
} from 'features/home/components/HomeSubscription/SubscriptionDetails/slice'
import { isExpiringSoon } from 'features/home/components/HomeSubscription/utils'
import {
  getHomeSubscriptonInfo,
  getHomeNetworkSubscriptonInfo,
} from 'features/home/utils'
import { DateTime } from 'luxon'
import PurchaseDeviceTotal from 'features/networkAi/NetworkWizard/PurchaseDeviceSubscription/PurchaseDeviceTotal'
import { fetchSubscriptionCreditsThunk } from 'features/home/components/HomeSubscription/slice'
import { SubscriptionCreditProduct } from '../../../../types'
import { SpinnerCentered } from 'components/Loader'

const SUBSCRIPTION_STATE = {
  NONE: 'NONE',
  ENROLLED: 'ENROLLED',
  WILL_NOT_RENEW: 'WILL_NOT_RENEW',
  EXPIRES: 'EXPIRES',
}

function CheckoutDetailsBlock() {
  const { homeId } = useHomeRouteParams()
  const dispatch = useAppDispatch()

  const home = useAppSelector(selectedHomeSelector.data)

  useEffect(() => {
    //dispatch(fetchHomeThunk(homeId))
    dispatch(fetchSubscriptionPeriodEndSliceSliceThunk(homeId))
  }, [homeId, dispatch])

  const subscribedAccessPoints = useAppSelector(subscribedAccessPointsSelector)
  const subscribedEssentials = useAppSelector(subscribedEssentialsSelector)

  const apPrice = useAppSelector(subscriptionApDevicePriceSelector)
  const essentialsPrice = useAppSelector(
    subscriptionEssentialsPriceSelector(subscribedEssentials?.hostTier)
  )
  const renewingStatus = useAppSelector(
    subscriptionStatusSelector(1, subscribedAccessPoints.count)
  )
  const renewDate = useAppSelector(subscriptionPeriodEndSelector.data)
  const creditAmounts = useAppSelector(subscriptionsCreditSelector.data)
  const creditAmountsLoading = useAppSelector(
    subscriptionsCreditSelector.isFetching
  )
  const subscriptionInfo = getHomeSubscriptonInfo(home)
  const subscriptionInfoNetwork = getHomeNetworkSubscriptonInfo(home)
  const [totalAmountDue, setTotalAmountDue] = useState(0)
  const [essentialsCredits, setEssentialsCredits] = useState(0)
  const [apCredits, setAPCredits] = useState(0)

  useEffect(() => {
    dispatch(fetchSubscriptionPricesSliceThunk(homeId))
  }, [dispatch, homeId])

  const subscriptionState = useMemo(() => {
    if (subscriptionInfo) {
      if (subscriptionInfo.autoRenew) return SUBSCRIPTION_STATE.ENROLLED
      return isExpiringSoon(subscriptionInfo, DateTime.now())
        ? SUBSCRIPTION_STATE.EXPIRES
        : SUBSCRIPTION_STATE.WILL_NOT_RENEW
    } else if (subscriptionInfoNetwork) {
      if (subscriptionInfoNetwork.autoRenew) return SUBSCRIPTION_STATE.ENROLLED
      return isExpiringSoon(subscriptionInfoNetwork, DateTime.now())
        ? SUBSCRIPTION_STATE.EXPIRES
        : SUBSCRIPTION_STATE.WILL_NOT_RENEW
    }
    return SUBSCRIPTION_STATE.NONE
  }, [subscriptionInfo, subscriptionInfoNetwork])

  useEffect(() => {
    let isMounted = true
    let total = 0
    if (isMounted) {
      if (
        renewingStatus !== undefined &&
        renewingStatus[3] !== 0 &&
        renewingStatus[3] !== undefined
      ) {
        total = renewingStatus[3] * (apPrice?.unit_amount || 0)
      }

      if (essentialsPrice !== undefined) {
        setTotalAmountDue(total + essentialsPrice?.unit_amount)
      } else {
        setTotalAmountDue(total)
      }
    }
    return () => {
      isMounted = false
    }
  }, [
    essentialsPrice,
    setTotalAmountDue,
    apPrice,
    renewingStatus,
    subscriptionState,
  ])

  const renewalDate = useMemo(() => {
    if (renewDate !== null) {
      if (
        subscribedAccessPoints.autoRenew === null ||
        subscribedAccessPoints.autoRenew === undefined
      ) {
        return [
          new Date().setFullYear(new Date().getFullYear() + 1),
          renewDate.data,
        ]
      } else {
        return [subscribedAccessPoints.autoRenew, renewDate.data]
      }
    } else {
      if (
        subscribedAccessPoints.autoRenew === null ||
        subscribedAccessPoints.autoRenew === undefined
      ) {
        return [
          new Date().setFullYear(new Date().getFullYear() + 1),
          new Date().setFullYear(new Date().getFullYear() + 1),
        ]
      } else {
        return [
          subscribedAccessPoints.autoRenew,
          subscribedAccessPoints.autoRenew,
        ]
      }
    }
  }, [subscribedAccessPoints, renewDate])

  useEffect(() => {
    const params = { after: renewalDate[1] }
    dispatch(fetchSubscriptionCreditsThunk(homeId, params))
  }, [dispatch, homeId, renewalDate])

  useEffect(() => {
    if (
      creditAmounts !== undefined &&
      creditAmounts?.products.length !== undefined &&
      creditAmounts?.products.length > 0
    ) {
      creditAmounts?.products.forEach(function (
        product: SubscriptionCreditProduct
      ) {
        if (product.productName === 'Savant Essentials') {
          setEssentialsCredits(product.amount)
        } else if (product.productName === 'Smart Network') {
          setAPCredits(product.amount)
        }
      })
    } else {
      setEssentialsCredits(0)
      setAPCredits(0)
    }
  }, [creditAmounts])

  return (
    <>
      {creditAmountsLoading ? (
        <SpinnerCentered size="40" />
      ) : (
        <PurchaseDeviceTotal
          apQuantity={
            renewingStatus !== undefined && renewingStatus[3] !== undefined
              ? renewingStatus[3]
              : 0
          }
          apPrice={apPrice?.unit_amount ?? 0}
          essentialsPrice={essentialsPrice?.unit_amount || 0}
          totalPrice={totalAmountDue}
          renewalDate={renewalDate[1]}
          subscriptionState={'ENROLLED'}
          essentialsCredits={essentialsCredits}
          apCredits={apCredits}
        />
      )}
    </>
  )
}

export default CheckoutDetailsBlock
